<template>
  <HeaderIconButton
    @click="switchType"
  >
    <template #icon>
      <SplitCircleSvg />
    </template>
    <template #label>
      {{ label }}
    </template>
  </HeaderIconButton>
</template>

<script>
import HeaderIconButton from '@/components/HeaderIconButton';
import SplitCircleSvg from '@/assets/images/icons/split-circle.svg?inline';

export default {
  components: {
    HeaderIconButton,
    SplitCircleSvg,
  },
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: {
    'update:modelValue': null,
  },
  computed: {
    label() {
      const nextType = this.modelValue === 'list' ? 'grid' : 'list';

      return `View as ${nextType}`;
    },
  },
  methods: {
    switchType() {
      if (this.modelValue === 'list') {
        this.$emit('update:modelValue', 'grid');
      } else {
        this.$emit('update:modelValue', 'list');
      }
    },
  },
};
</script>

<style lang="scss" module>

</style>
